import { Routes, Route  } from "react-router-dom";
import PublicPaths from "./PublicPaths";
import AgentsPaths from "./AgentPaths";
import AgentLayout from "../js/layout/private/AgentLayout";
import Layout from "../js/layout/Layout";


const RoutingPublicPaths = () => {
  const currentUrl = window.location.pathname;
  const path = currentUrl.toLowerCase();

  const isLandingPage = path.includes("landing");
  const isLoginPage = path.includes("partner-login");
  const isHome = path === "/" || path === "/it" || path === "/en" ;
  const getLayout = () => ( isLandingPage || isLoginPage || isHome ? null: <Layout /> );


  //languages paths router
  return(
    <>
      <Route path={"/"} element={ getLayout() } >
        { PublicPaths() }
      </Route>
      <Route path={"/it"} element={getLayout()} >
        { PublicPaths() }
      </Route>
      <Route path={"/en"} element={getLayout()} >
        { PublicPaths() }
      </Route>
    </>
  );
};

export default RoutingPublicPaths;
